// extracted by mini-css-extract-plugin
export default {"freeBet":"_2DvVs","dropdown":"_2SqnW","portal":"_1LFNd","disabledFreeBets":"_3q1P4","spinner":"_10eV7"};